import React from 'react';
import PropTypes from 'prop-types';

const UserCircleIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16">
        <path d="M8 0a8 8 0 108 8 8.009 8.009 0 00-8-8zm0 14.9A6.9 6.9 0 1114.9 8 6.911 6.911 0 018 14.903z" fill={fill} />
        <path d="M8.149 8.454a2.483 2.483 0 10-2.477-2.482 2.485 2.485 0 002.477 2.482zm0-3.869a1.386 1.386 0 11-1.386 1.386 1.388 1.388 0 011.386-1.385z" fill={fill} />
        <path d="M12.888 10.558a3.1 3.1 0 00-2.892-2.1.546.546 0 00-.362.107 2.457 2.457 0 01-2.971 0 .55.55 0 00-.362-.106 3.1 3.1 0 00-2.9 2.126.549.549 0 101.025.391 1.98 1.98 0 011.76-1.406 3.545 3.545 0 003.923 0 1.976 1.976 0 011.755 1.389.55.55 0 001.023-.4z" fill={fill} />
    </svg>
);

UserCircleIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

UserCircleIcon.defaultProps = {
    width: '16',
    height: '16',
    fill: '#4b254e'
};

export default UserCircleIcon;
